<template>
  <div
    class="card-sao-silvestre d-flex flex-column"
    :class="containerClasses"
    :style="cardStyle"
    :key="item.id_colaboracao"
  >
    <!-- Text Only -->
    <TextView
      v-if="renderMode === 'text' || renderMode === 'texto_fullscreen'"
      :header-text="userDisplayName"
      :complemento="item.dsc_complemento"
      :show-header="!hideUserInfo"
      :text="item.dsc_texto_colaboracao"
      :text-style="isFullScreen ? textContentStyleFullscreen : textContentStyle"
      :is-full-screen="isFullScreen"
      :colors="colorsConfig"
    />

    <!-- Audio -->
    <AudioView
      v-else-if="renderMode === 'audio'"
      :header-text="userDisplayName"
      :complemento="item.dsc_complemento"
      :show-header="!hideUserInfo"
      :audio-url="item.url_midia_colaboracao"
      :is-full-screen="isFullScreen"
      :colors="colorsConfig"
    />

    <!-- Media only (no text, no fullscreen) -->
    <MidiaView
      v-else-if="renderMode === 'midia'"
      :header-text="userDisplayName"
      :complemento="item.dsc_complemento"
      :show-header="!hideUserInfo"
      :midia-type="item.dsc_tipo_midia_colaboracao"
      :midia-url="item.url_midia_colaboracao"
      :midia-style="
        midiaOrientation === 'vertical'
          ? imageStyle
          : item.dsc_tipo_midia_colaboracao === 'video'
          ? videoStyle
          : imageStyle
      "
      :colors="colorsConfig"
    />

    <!-- Media only fullscreen -->
    <MidiaFullscreenView
      v-else-if="renderMode === 'midia_fullscreen'"
      :header-text="userDisplayName"
      :complemento="item.dsc_complemento"
      :show-header="!hideUserInfo"
      :midia-type="item.dsc_tipo_midia_colaboracao"
      :midia-url="item.url_midia_colaboracao"
      :midia-style="
        item.dsc_tipo_midia_colaboracao === 'video'
          ? videoStyleFullscreen
          : imageStyleFullscreen
      "
      :colors="colorsConfig"
    />

    <!-- Media with text - Horizontal -->
    <MidiaTextoHorizontalView
      v-else-if="renderMode === 'midia_texto' && midiaOrientation === 'horizontal'"
      :header-text="userDisplayName"
      :complemento="item.dsc_complemento"
      :show-header="!hideUserInfo"
      :midia-type="item.dsc_tipo_midia_colaboracao"
      :midia-url="item.url_midia_colaboracao"
      :midia-style="horizontalMediaStyle"
      :text="item.dsc_texto_colaboracao"
      :text-style="textContentStyle"
      :colors="colorsConfig"
    />

    <!-- Media with text - Vertical -->
    <MidiaTextoVerticalView
      v-else-if="renderMode === 'midia_texto' && midiaOrientation === 'vertical'"
      :header-text="userDisplayName"
      :complemento="item.dsc_complemento"
      :show-header="!hideUserInfo"
      :midia-type="item.dsc_tipo_midia_colaboracao"
      :midia-url="item.url_midia_colaboracao"
      :midia-style="verticalMediaStyle"
      :text="item.dsc_texto_colaboracao"
      :text-style="textContentStyle"
      :text-container-style="verticalTextContainerStyle"
      :colors="colorsConfig"
    />

    <!-- Media with text fullscreen - Horizontal -->
    <MidiaTextoHorizontalFullscreen
      v-else-if="
        renderMode === 'midia_texto_fullscreen' && midiaOrientation === 'horizontal'
      "
      :header-text="userDisplayName"
      :complemento="item.dsc_complemento"
      :show-header="!hideUserInfo"
      :midia-type="item.dsc_tipo_midia_colaboracao"
      :midia-url="item.url_midia_colaboracao"
      :midia-style="horizontalMediaStyleFullscreen"
      :video-style="horizontalVideoStyleFullscreen"
      :text="item.dsc_texto_colaboracao"
      :text-style="textContentStyleFullscreen"
      :colors="colorsConfig"
    />

    <!-- Media with text fullscreen - Vertical -->
    <MidiaTextoVerticalFullscreen
      v-else-if="
        renderMode === 'midia_texto_fullscreen' && midiaOrientation === 'vertical'
      "
      :header-text="userDisplayName"
      :complemento="item.dsc_complemento"
      :show-header="!hideUserInfo"
      :midia-type="item.dsc_tipo_midia_colaboracao"
      :midia-url="item.url_midia_colaboracao"
      :midia-style="verticalMediaStyleFullscreen"
      :text="item.dsc_texto_colaboracao"
      :text-style="textContentStyleFullscreen"
      :text-container-style="verticalTextContainerStyleFullscreen"
      :colors="colorsConfig"
    />
  </div>
</template>

<script>
import TextView from "@/components/Tarjas/SaoSilvestre/TextView.vue";
import AudioView from "@/components/Tarjas/SaoSilvestre/AudioView.vue";
import MidiaView from "@/components/Tarjas/SaoSilvestre/MidiaView.vue";
import MidiaFullscreenView from "@/components/Tarjas/SaoSilvestre/MidiaFullscreenView.vue";
import MidiaTextoHorizontalView from "@/components/Tarjas/SaoSilvestre/MidiaTextoHorizontalView.vue";
import MidiaTextoVerticalView from "@/components/Tarjas/SaoSilvestre/MidiaTextoVerticalView.vue";
import MidiaTextoHorizontalFullscreen from "@/components/Tarjas/SaoSilvestre/MidiaTextoHorizontalFullscreen.vue";
import MidiaTextoVerticalFullscreen from "@/components/Tarjas/SaoSilvestre/MidiaTextoVerticalFullscreen.vue";

export default {
  name: "CardSaoSilvestre",
  components: {
    TextView,
    AudioView,
    MidiaView,
    MidiaFullscreenView,
    MidiaTextoHorizontalView,
    MidiaTextoVerticalView,
    MidiaTextoHorizontalFullscreen,
    MidiaTextoVerticalFullscreen,
  },
  props: {
    item: Object,
    posicaoCard: String,
    isFullScreen: Boolean,
    hideUserInfo: Boolean,
    flg_exibir_uf: Boolean,
    configCores: Object,
  },
  data() {
    return {
      midiaOrientation: null,
      midiaDimension: {},
      percentScreenDim: {
        maxWidth: 40,
        minWidth: 20,
        minHeight: 30,
        maxHeight: 70,
        fullScreenMaxWidth: 60,
        fullScreenMaxHeight: 80,
        fullScreenMinWidth: 20,
        fullScreenMinHeight: 60,
      },
    };
  },
  created() {
    if (this.item.url_midia_colaboracao) {
      this.getMidiaOrientation();
    }
  },
  computed: {
    // Color computed properties with fallbacks
    backgroundColor() {
      return this.configCores?.dsc_hex_cor_background || "#ED4619";
    },
    backgroundColorEnd() {
      return this.configCores?.dsc_hex_cor_background_end || "#2C172C";
    },
    backgroundGradient() {
      return `linear-gradient(to bottom, ${this.backgroundColor}, ${this.backgroundColorEnd})`;
    },
    headerColor() {
      return this.configCores?.dsc_hex_cor_header || "#00a0b9";
    },
    textColor() {
      return this.configCores?.dsc_hex_cor_texto || "#4C1D23";
    },
    secondaryColor() {
      return this.configCores?.dsc_hex_cor_secundaria || "#DDDCDC";
    },
    boxShadowColor() {
      return this.configCores?.dsc_hex_cor_sombra || "#ED4619";
    },

    // Colors config object to pass to sub-components
    colorsConfig() {
      return {
        backgroundColor: this.backgroundColor,
        backgroundColorEnd: this.backgroundColorEnd,
        headerColor: this.headerColor,
        textColor: this.textColor,
        secondaryColor: this.secondaryColor,
        boxShadowColor: this.boxShadowColor,
      };
    },

    // User display name
    userDisplayName() {
      if (this.flg_exibir_uf && this.item.dsc_uf_colaborador) {
        return `${this.item.dsc_nome_colaborador} - ${this.item.dsc_uf_colaborador}`;
      }
      return this.item.dsc_nome_colaborador;
    },

    // Render mode determination
    renderMode() {
      const mediaType = this.item.dsc_tipo_midia_colaboracao;
      const hasText = this.item.dsc_texto_colaboracao && this.item.flg_exibir_texto;
      const isImageOrVideo = ["image", "video"].includes(mediaType);

      if (mediaType === "audio") {
        return "audio";
      }
      if (isImageOrVideo && !hasText && !this.isFullScreen) {
        return "midia";
      }
      if (isImageOrVideo && !hasText && this.isFullScreen) {
        return "midia_fullscreen";
      }
      if (isImageOrVideo && hasText && this.isFullScreen) {
        return "midia_texto_fullscreen";
      }
      if (isImageOrVideo && hasText && !this.isFullScreen) {
        return "midia_texto";
      }
      if (hasText && this.isFullScreen && !this.item.url_midia_colaboracao) {
        return "texto_fullscreen";
      }
      return "text";
    },

    // Screen dimensions
    screenDimensions() {
      return {
        width: this.$vuetify.breakpoint.width,
        height: this.$vuetify.breakpoint.height,
      };
    },

    // Text sizing
    textCharCount() {
      return this.item.dsc_texto_colaboracao?.trim().length || 0;
    },

    textContentStyle() {
      return {
        lineHeight: this.getLineHeight(this.textCharCount, false),
        fontSize: this.getTextSize(this.textCharCount, false),
        wordBreak: "break-word",
      };
    },

    textContentStyleFullscreen() {
      return {
        lineHeight: this.getLineHeight(this.textCharCount, true),
        fontSize: this.getTextSize(this.textCharCount, true),
        wordBreak: "break-word",
      };
    },

    // Container classes
    containerClasses() {
      const hasMediaNoText = this.item.url_midia_colaboracao && !this.isFullScreen;

      return [hasMediaNoText ? "mb-14" : !this.isFullScreen ? "mb-10" : "pa-3"];
    },

    // Media styles
    imageStyle() {
      const { width, height } = this.screenDimensions;
      if (this.midiaOrientation === "vertical") {
        return `max-width: ${(60 * width) / 100}px; max-height: ${
          (90 * height) / 100
        }px; height: 50vh !important; justify-self: center;`;
      }
      if (this.midiaOrientation === "horizontal") {
        return `max-width: ${(60 * width) / 100}px; max-height: ${
          (90 * height) / 100
        }px; width: 30vw !important; justify-self: center;`;
      }
      return "max-width: 400px; max-height: 580px; width: 30vw; height: 30vh; justify-self: center;";
    },

    imageStyleFullscreen() {
      const { width, height } = this.screenDimensions;
      if (this.midiaOrientation === "vertical") {
        return `max-width: ${(60 * width) / 100}px; max-height: ${
          (90 * height) / 100
        }px; height: 70vh !important;`;
      }
      if (this.midiaOrientation === "horizontal") {
        return `max-width: ${(58 * width) / 100}px; max-height: ${
          (90 * height) / 100
        }px; width: 60vw !important;`;
      }
      return "max-width: 400px; max-height: 580px; width: 30vw; height: 30vh;";
    },

    videoStyle() {
      const { width, height } = this.screenDimensions;
      const { maxWidth, maxHeight } = this.percentScreenDim;
      return `max-width: ${(maxWidth * width) / 100 - 20}px; max-height: ${
        (maxHeight * height) / 100 - 50
      }px; justify-self: center;`;
    },

    videoStyleFullscreen() {
      const { width, height } = this.screenDimensions;
      const { fullScreenMaxWidth, fullScreenMaxHeight } = this.percentScreenDim;
      if (this.midiaOrientation === "vertical") {
        return `max-width: ${(60 * width) / 100}px; max-height: ${
          (fullScreenMaxHeight * height) / 100
        }px; height: 70vh !important; justify-self: center;`;
      }
      return `max-height: ${(fullScreenMaxHeight * height) / 100}px; max-width: ${
        (fullScreenMaxWidth * width) / 100
      }px; justify-self: center;`;
    },

    horizontalMediaStyle() {
      const { width, height } = this.screenDimensions;
      const { maxWidth, maxHeight } = this.percentScreenDim;
      return `max-width: ${(maxWidth * width) / 100 - 20}px; max-height: ${
        (maxHeight * height) / 100 - 50
      }px;`;
    },

    horizontalMediaStyleFullscreen() {
      const { width, height } = this.screenDimensions;
      const {
        fullScreenMaxWidth,
        fullScreenMaxHeight,
        fullScreenMinHeight,
      } = this.percentScreenDim;
      return `max-width: ${(fullScreenMaxWidth * width) / 100}px; max-height: ${
        (fullScreenMaxHeight * height) / 100
      }px; min-height: ${(fullScreenMinHeight * height) / 100}px; height: 50vh;`;
    },

    horizontalVideoStyleFullscreen() {
      const { width, height } = this.screenDimensions;
      const { fullScreenMinHeight } = this.percentScreenDim;
      return `max-height: ${(80 * height) / 100}px; max-width: ${
        (60 * width) / 100
      }px; min-height: ${
        (fullScreenMinHeight * height) / 100
      }px; height: 50vh; justify-self: center;`;
    },

    verticalMediaStyle() {
      return "max-height: 580px; height: 50vh;";
    },

    verticalMediaStyleFullscreen() {
      const { width, height } = this.screenDimensions;
      const { fullScreenMinHeight } = this.percentScreenDim;
      return `max-width: ${(60 * width) / 100}px; max-height: ${
        (80 * height) / 100
      }px; min-height: ${(fullScreenMinHeight * height) / 100}px; height: 50vh;`;
    },

    verticalTextContainerStyle() {
      const { width } = this.screenDimensions;
      return `max-width: ${(33.5 * width) / 100}px; min-width: ${
        (33.5 * width) / 100
      }px;`;
    },

    verticalTextContainerStyleFullscreen() {
      const { width } = this.screenDimensions;
      return `max-width: ${(33.5 * width) / 100}px;`;
    },

    cardStyle() {
      const { width, height } = this.screenDimensions;
      const dim = this.percentScreenDim;

      if (this.isFullScreen) {
        let minWidth = (dim.fullScreenMinWidth * width) / 100;
        let maxWidth = (dim.fullScreenMaxWidth * width) / 100 + 20;
        let minHeight = (dim.fullScreenMinHeight * height) / 100;
        let maxHeight = (dim.fullScreenMaxHeight * height) / 100 + 50;

        if (this.renderMode === "texto_fullscreen") {
          minWidth = ((dim.fullScreenMinWidth - 10) * width) / 100;
          minHeight = ((dim.fullScreenMinHeight - 30) * height) / 100;
        }

        if (this.renderMode === "audio") {
          // Audio in fullscreen should have same proportions as normal audio (640x160)
          return `justify-self: center; width: 640px; height: 160px;`;
        }

        return `justify-self: center; max-width: ${maxWidth}px !important; max-height: ${maxHeight}px !important; min-width: ${minWidth}px !important; min-height: ${minHeight}px !important;`;
      }

      // Non-fullscreen positioning
      let position = "";
      const hasMedia = this.item.url_midia_colaboracao;

      if (this.posicaoCard === "esquerda" && !hasMedia) {
        position = "margin-left: 100px; justify-self: flex-start";
      } else if (this.posicaoCard === "centro") {
        position = "justify-self: center";
      } else if (this.posicaoCard === "direita" && !hasMedia) {
        position = "margin-right: 40px; justify-self: flex-end";
      } else if (this.posicaoCard === "direita" && hasMedia) {
        position = "margin-right: 60px; justify-self: flex-start";
      } else if (this.posicaoCard === "esquerda" && hasMedia) {
        position = "margin-left: 120px; justify-self: flex-start";
      }

      const maxW = (40 * width) / 100;
      const maxH = (80 * height) / 100;
      const mediaType = this.item.dsc_tipo_midia_colaboracao;
      const hasText = this.item.dsc_texto_colaboracao;

      let dimensions = "";
      if (["video", "image"].includes(mediaType) && !hasText) {
        dimensions = `max-width: ${maxW}px; max-height: ${maxH}px !important;`;
      } else if (hasMedia && hasText && this.midiaOrientation === "horizontal") {
        dimensions = `max-width: ${maxW}px; max-height: ${maxH}px !important;`;
      } else if (hasMedia && hasText && this.midiaOrientation === "vertical") {
        dimensions = `max-width: auto !important; max-height: ${maxH}px !important;`;
      } else {
        dimensions = "width: 640px; height: 160px;";
      }

      return [position, dimensions].filter(Boolean).join("; ");
    },
  },
  methods: {
    getTextSize(numChars, isFullScreen) {
      if (isFullScreen) {
        if (numChars <= 40) return "3rem";
        if (numChars <= 80) return "2.7rem";
        if (numChars <= 120) return "2.5rem";
        if (numChars <= 160) return "2.3rem";
        if (numChars <= 200) return "2rem";
        if (numChars <= 240) return "1.9rem";
        if (numChars <= 280) return "1.8rem";
        return "1.5rem";
      }
      if (numChars <= 40) return "2.2rem";
      if (numChars <= 80) return "2.1rem";
      if (numChars <= 120) return "1.8rem";
      if (numChars <= 160) return "1.6rem";
      if (numChars <= 200) return "1.5rem";
      if (numChars <= 240) return "1.4rem";
      if (numChars <= 280) return "1.3rem";
      return "1.5rem";
    },

    getLineHeight(numChars, isFullScreen) {
      if (isFullScreen) {
        if (numChars <= 40) return "3rem";
        if (numChars <= 80) return "2.7rem";
        if (numChars <= 120) return "2.5rem";
        if (numChars <= 160) return "2.3rem";
        if (numChars <= 200) return "2.1rem";
        if (numChars <= 240) return "2rem";
        if (numChars <= 280) return "1.9rem";
        return "1.5rem";
      }
      if (numChars <= 40) return "2.55rem";
      if (numChars <= 80) return "1.9rem";
      if (numChars <= 120) return "1.85rem";
      if (numChars <= 160) return "1.6rem";
      if (numChars <= 200) return "1.5rem";
      if (numChars <= 240) return "1.4rem";
      if (numChars <= 280) return "1.2rem";
      return "1.5rem";
    },

    getMidiaOrientation() {
      if (!this.item.url_midia_colaboracao) return;

      if (this.item.dsc_tipo_midia_colaboracao === "image") {
        const image = new Image();
        image.src = this.item.url_midia_colaboracao;
        image.onload = () => {
          this.midiaDimension = { width: image.width, height: image.height };
          this.midiaOrientation = image.height > image.width ? "vertical" : "horizontal";
        };
      } else if (this.item.dsc_tipo_midia_colaboracao === "video") {
        const video = document.createElement("video");
        video.src = this.item.url_midia_colaboracao;
        video.style.visibility = "hidden";
        document.body.appendChild(video);
        video.addEventListener("loadedmetadata", () => {
          this.midiaDimension = {
            width: video.videoWidth,
            height: video.videoHeight,
          };
          this.midiaOrientation =
            video.videoHeight > video.videoWidth ? "vertical" : "horizontal";
          document.body.removeChild(video);
        });
      }
    },
  },
  watch: {
    item(newValue) {
      if (newValue.url_midia_colaboracao) {
        this.getMidiaOrientation();
      }
    },
    cardStyle() {
      this.getMidiaOrientation();
    },
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Globotipo";
  src: url("@/assets/Globotipo_Regular.otf") format("opentype");
}

@font-face {
  font-family: "ZuumeEdge";
  src: url("@/assets/SaoSilvestre/fonts/zuume_edge_bold_italic.otf") format("opentype");
}
</style>

<style lang="scss" scoped>
.card-sao-silvestre {
  --bg-color: v-bind(backgroundColor);
  --bg-color-end: v-bind(backgroundColorEnd);
  --bg-gradient: v-bind(backgroundGradient);
  --header-color: v-bind(headerColor);
  --text-color: v-bind(textColor);
  --secondary-color: v-bind(secondaryColor);
  --shadow-color: v-bind(boxShadowColor);
}

.wrapper-card {
  padding: 5px 5px 5px 5px;
  border-radius: 20px 20px 0 0;
  box-shadow: inset 0 40px 10px -25px var(--bg-color);
}

.bg-default {
  background: var(--bg-gradient);
}
</style>
